import { createContext } from 'react';

const SingleCaseContext = createContext(null);

export default SingleCaseContext;
